import { useSyncExternalStore } from 'react'

import { ouvirVerificacoes, verificacoesGuardadas, type ResultadoGeorref } from './verificacoesGeorref'

/** As verificações da georreferência de um modelo, a acompanhar o
 *  resultado quando ele chega (depois de o modelo abrir). */
export function useVerificacoesGeorref(modelId: string | null): ResultadoGeorref | undefined {
  return useSyncExternalStore(ouvirVerificacoes, () => (modelId ? verificacoesGuardadas(modelId) : undefined))
}
